const isFullUrl = (url?: string): boolean => {
  if (!url) {
    return false;
  }

  return url.startsWith('http://') || url.startsWith('https://');
};

export default isFullUrl;
